import ResponsiveCarousel from '../shared/responsiveCarousel';

const CategoriesSlider = {
	init: function() {
		const $sliders = [...document.querySelectorAll('.categories-carousel')];

		this._updateSliders($sliders);

		window.addEventListener('resize', this._debounce(() => this._updateSliders($sliders)));
	},
	_updateSliders: function($sliders){
		if(this.sliderInstances){
			this.sliderInstances.forEach(slider => slider.destroy());
		}

		const options = this._getOptionsForScreenSize(window.innerWidth);

		this.sliderInstances = $sliders.map($slider => new ResponsiveCarousel($slider, options));
	},
	_getOptionsForScreenSize: function(currentWidth){
		const largeScreenWidth = 767;
		if(currentWidth > largeScreenWidth){
			return {
				type: 'loop',
				perPage: 5,
				perMove: 5,
				padding: 80,
				start: 2,
				focus: 'center',
				autoWidth: true,
				pagination: false,
				speed: 1000,
				arrowPath: 'M35,20L5,40L5,0L35,20z',
				classes: {
					arrows: 'splide__arrows carousel-controls',
					arrow: 'splide__arrow carousel-arrow',
					prev: 'splide__arrow--prev carousel-prev',
					next: 'splide__arrow--next carousel-next',
				},
				breakpoints: {
					1376: {
						focus: 'center',
						perMove: 5,
						padding: 0,
					},
					1200: {
						focus: 'center',
						perMove: 5,
						padding: 0,
					},
					1100: {
						focus: 'center',
						perMove: 4,
						padding: {
							left: '21vw',
						}
					},
				}
			};
		}

		return {
			type: 'loop',
			perPage: 3,
			perMove: 3,
			start: 1,
			focus: 'center',
			autoWidth: true,
			pagination: false,
			speed: 800,
			arrowPath: 'M35,20L5,40L5,0L35,20z',
			classes: {
				arrows: 'splide__arrows carousel-controls',
				arrow: 'splide__arrow carousel-arrow',
				prev: 'splide__arrow--prev carousel-prev',
				next: 'splide__arrow--next carousel-next',
			},
			breakpoints: {
				768: {
					focus: 'center',
					perMove: 3,
					padding: 0,
				},
				501: {
					focus: 2,
					perMove: 2,
					padding: {
						left: '24px',
					},
				},
				321: {
					focus: 1,
					perMove: 1,
					padding: {
						left: '24px',
					},
				},
			}
		};
	},
	// Prevent an event from being triggered too much
	_debounce: function(func, timeout = 500){
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(null, args);
			}, timeout);
		};
	}
};

export default CategoriesSlider;
